function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "se-a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M-53.4 0h682.6v512H-53.4z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#se-a)",
  transform: "translate(50) scale(.9375)"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeWidth: "1pt"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#006aa7",
  d: "M-121.1.3h256v204.8h-256zm0 306.9h256V512h-256z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fecc00",
  d: "M-121.1 205h256v102.4h-256z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fecc00",
  d: "M133.8 0h102.4v512H133.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fecc00",
  d: "M233 205h460.8v102.4H233z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006aa7",
  d: "M236.2 307.2H697V512H236.2zm0-306.9H697v204.8H236.2z"
})));

var SvgSv = function SvgSv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-icon-css-se",
    viewBox: "0 0 640 480",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sv.ee9cde49.svg";
export { ForwardRef as ReactComponent };